import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type TemplateFieldTypesFetchFailedAction = {
	type: 'TEMPLATE_FIELD_TYPES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): TemplateFieldTypesFetchFailedAction => ({
	type: 'TEMPLATE_FIELD_TYPES_FETCH_FAILED',
	payload,
});
